import { put, takeLatest } from "redux-saga/effects";
import {
  fetchProjectDynamosRequest,
  fetchProjectDynamosSuccess,
  fetchProjectDynamosFailure,
  createProjectDynamoRequest,
  createProjectDynamoSuccess,
  createProjectDynamoFailure,
  updateProjectDynamoRequest,
  updateProjectDynamoSuccess,
  updateProjectDynamoFailure,
  createLapRequest,
  createLapSuccess,
  createLapFailure,
  updateLapRequest,
  updateLapSuccess,
  updateLapFailure,
} from "./projectDynamosSlice";
import { fastApiURL } from "../../utils/config";
import TokenManager from "../../utils/tokenManager"; 


function* fetchProjectDynamosSaga(action) {
  try {
    const { projectId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("User not authenticated");

    const response = yield fetch(`${fastApiURL}/api/projects/${projectId}/dynamos`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`, 
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load project dynamos: ${response.status}`);
    }

    const data = yield response.json();
    yield put(
      fetchProjectDynamosSuccess({
        projectId,
        drafts: data.drafts || [],
        published: data.published || [],
      })
    );
  } catch (error) {
    console.error("Error in fetchProjectDynamosSaga:", error);
    yield put(fetchProjectDynamosFailure(error.message));
  }
}

function* createProjectDynamoSaga(action) {
  try {
    const { projectId, title, introduction, status } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("User not authenticated");

    const response = yield fetch(`${fastApiURL}/api/projects/${projectId}/dynamos`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify({
        title,
        introduction,
        status: status || "draft",
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to create dynamo: ${response.status}`);
    }

    const dynamo = yield response.json();
    yield put(
      createProjectDynamoSuccess({
        projectId,
        dynamo,
      })
    );
  } catch (error) {
    console.error("Error in createProjectDynamoSaga:", error);
    yield put(createProjectDynamoFailure(error.message));
  }
}

function* updateProjectDynamoSaga(action) {
  try {
    const { projectId, dynamoId, updates } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("User not authenticated");

    const response = yield fetch(`${fastApiURL}/api/projects/${projectId}/dynamos/${dynamoId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify(updates || {}),
    });

    if (!response.ok) {
      throw new Error(`Failed to update dynamo: ${response.status}`);
    }

    const dynamo = yield response.json();
    yield put(
      updateProjectDynamoSuccess({
        projectId,
        dynamo,
      })
    );
  } catch (error) {
    console.error("Error in updateProjectDynamoSaga:", error);
    yield put(updateProjectDynamoFailure(error.message));
  }
}

function* createLapSaga(action) {
  try {
    const { projectId, dynamoId, mandatoryFields, optionalFields } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("User not authenticated");

    const response = yield fetch(`${fastApiURL}/api/projects/${projectId}/dynamos/${dynamoId}/laps`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify({
        mandatory_fields: mandatoryFields,
        optional_fields: optionalFields,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to create LAP: ${response.status}`);
    }

    const lap = yield response.json();
    yield put(
      createLapSuccess({
        projectId,
        dynamoId,
        lap,
      })
    );
  } catch (error) {
    console.error("Error in createLapSaga:", error);
    yield put(createLapFailure(error.message));
  }
}

function* updateLapSaga(action) {
  try {
    const { projectId, dynamoId, lapId, updates } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("User not authenticated");

    const response = yield fetch(
      `${fastApiURL}/api/projects/${projectId}/dynamos/${dynamoId}/laps/${lapId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`, 
        },
        body: JSON.stringify(updates || {}),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to update LAP: ${response.status}`);
    }

    const lap = yield response.json();
    yield put(
      updateLapSuccess({
        projectId,
        dynamoId,
        lap,
      })
    );
  } catch (error) {
    console.error("Error in updateLapSaga:", error);
    yield put(updateLapFailure(error.message));
  }
}

export function* watchProjectDynamosSaga() {
  yield takeLatest(fetchProjectDynamosRequest, fetchProjectDynamosSaga);
  yield takeLatest(createProjectDynamoRequest, createProjectDynamoSaga);
  yield takeLatest(updateProjectDynamoRequest, updateProjectDynamoSaga);
  yield takeLatest(createLapRequest, createLapSaga);
  yield takeLatest(updateLapRequest, updateLapSaga);
}